import { Component, EventEmitter, Injector, Input, Output, QueryList, SimpleChanges, ViewChild, ViewChildren, ViewContainerRef } from '@angular/core';
import { MatTableDataSource, MatRow } from '@angular/material/table';
import { Observable, Subscription } from 'rxjs';
import { BaseComponent } from 'src/app/common/base/base.component';
import { ResourceType } from 'src/app/common/enumerations/enumerations';
import { utils } from 'src/app/modules/libs/utils';
import { Resource } from '../../beamline-catalog/resource/resources';
import { ResourcesService } from '../../beamline-catalog/resource/resources.service';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'rssd-list-side',
  templateUrl: './rssd-list-side.component.html',
  styleUrls: ['./rssd-list-side.component.scss']
})
export class RssdListSideComponent extends BaseComponent {

  @Input() filter?: string | null;
  //@Output() loading = new EventEmitter<boolean>();

  displayedColumns: string[] = [
    'name',
    'type'
  ];
  dataSource = new MatTableDataSource<Resource>();

  @Output() rowSelected = new EventEmitter<any>();
  @Output() rowsFiltered = new EventEmitter<Resource[]>();

  @ViewChildren('matrow', { read: ViewContainerRef }) rows?: QueryList<ViewContainerRef>;
  @ViewChildren('matrow') datarows?: QueryList<MatRow>;

  allowNew = false;
  disabled = false;
  maxHeight!: string;

  resource?: Resource | null;
  resources?: Resource[];
  allResources?: Resource[];
  resourcesFiltered?: Resource[];
  resources$!: Observable<Resource[]>;
  resourcesSubs!: Subscription;

  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    protected override injector: Injector,
    private service: ResourcesService
  ) {
    super(injector);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filter']) {
      this.applyFilter();
    }
  }

  override ngOnDestroy(): void {
    this.resourcesSubs?.unsubscribe();
  }

  ngOnInit(): void {
    this.loadResources();
  }

  loadResources() {
    this.resources$ = this.store.select(state => state.Resources.data);
    this.resourcesSubs = this.resources$.subscribe(data => {
      if (data?.length) {

        // Keep the complete resource collection so shielding relationships can be resolved locally.
        this.allResources = data;
        this.resources = data.filter(r => r.type == ResourceType.Accelerator || r.type == ResourceType.Shutter);
        this.createDataSource();
      }
    });
  }

  createDataSource() {
    this.resourcesFiltered = this.resources?.filter(r => this.hasRSSDs(r))
      .filter(r => this.filter ? (r.displayName?.includes(this.filter.toLowerCase()) || r.name?.includes(this.filter.toLowerCase())) : true);

    this.resourcesFiltered?.map(r => r.displayName = r.type == ResourceType.Accelerator ? r.name : r.childResources?.find(r => r.childResourceType == ResourceType.Beamline)?.childResourceName);
    this.resourcesFiltered = this.resourcesFiltered?.sort((a, b) => this.utils.sortArrayAlphabeticallyWithComplexNumbers((a.type?.toString() ?? '0') + a.displayName, (b.type?.toString() ?? '0') + b.displayName));
    this.dataSource = new MatTableDataSource(this.resourcesFiltered);
    this.setSortingAccessor();
    this.rowsFiltered.emit(this.resourcesFiltered);
  }

  setSortingAccessor() {
    // Define the sorting accessor
    this.dataSource.sortingDataAccessor = (element, property) => {
      switch (property) {
        case 'name':
          return element.displayName;
        case 'type':
          return element.resourceType?.name;
        default:
          return (element as any)[property]; // Fallback to the default property
      }
    };
    this.setSort<Resource>(this.dataSource, this.sort);
  }

  /**
   * Determines whether a resource references shielding configured as an RSSD.
   * Hydrates every shielding relationship so all matching RSSDs can be displayed.
   * @param r Resource whose child shielding relationships are evaluated.
   */
  hasRSSDs(r: Resource) {
    const shieldingRelationships = r.childResources?.filter(c => c.childResourceType == ResourceType.Shielding) ?? [];

    shieldingRelationships.forEach(c => {
      if (!c.childResource) {
        // Resolve child details from the loaded catalog when the relationship is ID-only.
        c.childResource = this.allResources?.find(x => x.id == c.childResourceID) ?? null;
      }
    });

    // Check after hydration so finding one RSSD does not prevent later relationships from being resolved.
    return shieldingRelationships.some(c => c.childResource?.isRSSD ?? false);
  }

  rowUnselected() {
    this.resource = null;
    this.rowSelected.emit(null);
  }

  rowClicked(row: Resource) {
    if (this.resource?.id == row.id) {
      this.rowUnselected();
      //this.loading.emit(false);
    }
    else {
      this.getValues(row);
    }
  }

  async getValues(row: Resource) {
    if (row?.id) {
      this.resource = row;
      this.rowSelected.emit(this.resource);
    }
  }
  //#endregion LOAD

  //#region ADD

  unselect() {

  }

  //#endregion

  //#region FILTERS

  applyFilter() {
    this.createDataSource();
    this.dataSource.filter = this.filter?.trim().toLowerCase() ?? '';
  }

  changeClosed() {
    this.applyFilter();
  }

  async refresh() {

  }

  //#endregion

  // #region TableScroll
  showElement(index: number, height: number) {
    const indexstr = index.toString();
    const row = this.rows?.find(
      (r) => r.element.nativeElement.getAttribute('position') === indexstr
    );
    if (row) {
      const rect = row.element.nativeElement.getBoundingClientRect();
      if (rect.y <= 0 || rect.y + rect.height > height) {
        row.element.nativeElement.scrollIntoView(false, {
          behavior: 'instant',
        });
      }
      return;
    }
    console.log('not found');
  }

  getPosition(row: any): number {
    const i = this.dataSource.data.findIndex((r) => {
      return r.id === row.id;
    });
    return i;
  }

  formatLocationNames(locationNames: string) {
    if (locationNames) {
      return utils.replaceAll(locationNames, ',', ', ');
    }
    return '';
  }

}
